<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<p class="Title">CONTENTS</p>
<div class="paraNoIndentH"><hr/></div>
<p class="tocpara1" style="margin-top: 5%;"><a href="#/07_prologue">PROLOGUE</a></p>
<p class="tocpara1"><a href="#/08_intro">INTRODUCTION: <em class="italic">Helicopters</em></a></p>
<p class="tocparaA"><a href="#/09_part01">FLYING LIFE ONE: <em class="italic">The Army 1968–1971</em></a></p>
<p class="tocpara">  <a href="#/10_chapter01">1:   The Accidental Aviator</a></p>
<p class="tocpara">  <a href="#/11_chapter02">2:   Chasing Buzzards</a></p>
<p class="tocpara">  <a href="#/12_chapter03">3:   Engine Failure</a></p>
<p class="tocpara">  <span href="#/13_chapter04" title="Link target outside of Sample">4:   The Playtex Club</span></p>
<p class="tocpara">  <span href="#/14_chapter05" title="Link target outside of Sample">5:   First takeoff of the Day</span></p>
<p class="tocpara">  <span href="#/15_chapter06" title="Link target outside of Sample">6:   Luck and Superstition</span></p>
<p class="tocpara">  <span href="#/16_chapter07" title="Link target outside of Sample">7:   Survival Instruments</span></p>
<p class="tocpara">  <span href="#/17_chapter08" title="Link target outside of Sample">8:   Tracers</span></p>
<p class="tocpara">  <span href="#/18_chapter09" title="Link target outside of Sample">9:   Army Night Flight</span></p>
<p class="tocpara"><span href="#/19_chapter10" title="Link target outside of Sample">10:   Flares</span></p>
<p class="tocpara"><span href="#/20_chapter11" title="Link target outside of Sample">11:   Napalm</span></p>
<p class="tocpara"><span href="#/21_chapter12" title="Link target outside of Sample">12:   Last ’Nam Flight</span></p>
<p class="tocparaA"><span href="#/22_part02" title="Link target outside of Sample">FLYING LIFE TWO: <em class="italic">The National Guard 1972–1975</em></span></p>
<p class="tocpara"><span href="#/23_chapter13" title="Link target outside of Sample">13:   Truck Strike</span></p>
<p class="tocpara"><span href="#/24_chapter14" title="Link target outside of Sample">14:   National Guard Night Flight</span></p>
<p class="tocpara"><span href="#/52_chapter15" title="Link target outside of Sample">15:   Tornados</span></p>
<p class="tocpara"><span href="#/53_chapter16" title="Link target outside of Sample">16:   National Guard Summers</span></p>
<p class="tocparaA"><span href="#/54_part03" title="Link target outside of Sample">FLYING LIFE THREE: <em class="italic">The Marine Corps 1975–1973</em></span></p>
<p class="tocpara"><span href="#/55_chapter17" title="Link target outside of Sample">17:   Night Vision Goggles</span></p>
<p class="tocpara"><span href="#/56_chapter18" title="Link target outside of Sample">18:   Marine Corps Night Flight</span></p>
<p class="tocpara"><span href="#/57_chapter19" title="Link target outside of Sample">19:   Wires</span></p>
<p class="tocpara"><span href="#/58_chapter20" title="Link target outside of Sample">20:   Externals</span></p>
<p class="tocpara"><span href="#/59_chapter21" title="Link target outside of Sample">21:   The Ritual</span></p>
<p class="tocpara"><span href="#/60_chapter22" title="Link target outside of Sample">22:   Special Operations Capable</span></p>
<p class="tocpara"><span href="#/61_chapter23" title="Link target outside of Sample">23:   Broken on a moroccan Beach</span></p>
<p class="tocparaA"><span href="#/61i_part04" title="Link target outside of Sample">FLYING LIFE FOUR: <em class="italic">The British Royal Navy 1983–1985</em></span></p>
<p class="tocpara"><span href="#/62_chapter24" title="Link target outside of Sample">24:   Sand</span></p>
<p class="tocpara"><span href="#/63_chapter25" title="Link target outside of Sample">25:   Introducing the Arctic to Captain Curtis</span></p>
<p class="tocpara"><span href="#/64_chapter26" title="Link target outside of Sample">26:   Royal Navy Night Flight—the Difficult Valley</span></p>
<p class="tocpara"><span href="#/65_chapter27" title="Link target outside of Sample">27:   Troop Lifting, with Night and Heavy Snow Showers</span></p>
<p class="tocpara"><span href="#/66_chapter28" title="Link target outside of Sample">28:   Long Flight Home</span></p>
<p class="tocpara"><span href="#/67_chapter29" title="Link target outside of Sample">29:   Sea Fog</span></p>
<p class="tocpara"><span href="#/68_chapter30" title="Link target outside of Sample">30:   Day and Night Passengers</span></p>
<p class="tocpara"><span href="#/69_chapter31" title="Link target outside of Sample">31:   Final Flight with the Royal Navy</span></p>
<p class="tocpara1"><span href="#/70_epilogue" title="Link target outside of Sample">EPILOGUE: <em class="italic">The Wall, 20 Years After</em></span></p>
<p class="tocpara1"><span href="#/71_glossary" title="Link target outside of Sample">GLOSSARY</span></p>
<p class="tocpara1"><span href="#/72_ack" title="Link target outside of Sample">ACKNOWLEDGMENTS</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_toc.vue?4aa3cea8